<template>
  <div>
    <v-container grid-list-md class="pa-0" fluid>
      <v-layout row wrap>
        <v-flex md3 xs12>
          <v-select
            v-if="!loading && companies.length > 1"
            :items="filteredCompanies"
            :item-color="companyPrimaryColor"
            :background-color="$vuetify.theme.themes[theme].menu"
            item-text="name"
            item-value="id"
            hide-details
            v-on:input="loadActiveCompData()"
            v-model="activeComp"
            no-data-text="Geen bedrijven gevonden."
            label="Selecteer bedrijf"
            outlined
            dense
            >
            <template v-slot:prepend-item>
              <v-list-item>
                <v-list-item-content  class="pt-0" >
                  <v-text-field
                    :color="companyPrimaryColor"
                    placeholder="Zoeken"
                    append-icon="search"
                    v-model="searchCompanies"
                    hide-details
                    dense
                  ></v-text-field>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <div v-if="searchCompanies && searchCompanies.length > 0" style="padding: 4px 17px 3px 17px; background-color:rgba(0,0,0, 0.02); color: rgba(0, 0, 0, 0.6); text-align: center; font-size: 12px">{{ filteredCompanies.length }} van {{ companies.length }} bedrijven</div>
              <v-divider v-if="searchCompanies && searchCompanies.length > 0"></v-divider>
            </template>
          </v-select>
        </v-flex>
      </v-layout>
    </v-container>

    <div v-if="loading" class="blackbox-loader"></div>

    <div v-if="loading == false" class="mt-4 special-content-box">
      <v-tabs
        :color="companyPrimaryColor"
        background-color="background"
        show-arrows
        >
        <v-tab @click="tab='3'" >Kernactiviteiten</v-tab>
        <v-tab @click="tab='1', showEmployees()" >Medewerkers</v-tab>
        <v-tab @click="tab='2'" >Functies</v-tab>
        <v-tab @click="tab='4'" >Resultaatgebieden</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item value="1" :transition="tabTransition" :reverse-transition="tabTransition">
          <div class="pa-4">
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex md8 xs12>
                  <h1 class="tab-title">Medewerkers</h1>
                </v-flex>
                <v-flex md4 xs12>
                  <v-row v-if="employeesLoaded && employees.length > 0">
                    <v-text-field
                      class="px-2"
                      v-model="searchEmployees"
                      :color="companyPrimaryColor"
                      name="searchfield"
                      placeholder="Zoeken"
                      outlined
                      hide-details                                                     
                      prepend-inner-icon="search"
                      autocomplete="disabled"
                      backgroundColor="background"
                      clearable
                      single-line>
                    </v-text-field>
                    <v-btn class="px-2" fab dark :color="companyPrimaryColor" @click="addEmployee()">
                      <v-icon darken>add</v-icon>
                    </v-btn>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div v-if="employeesLoaded && employees.length > 0">
            <div v-if="employees.length > 0">
              <v-data-table
                :key="watcher"
                :search="searchEmployees"
                :headers="headersEmployee"
                :items="employees"
                hide-default-footer
                single-expand
                :sort-by="['order']"
                :itemsPerPage.sync="employeesPages"
                class="table-employees"
                >
                <template v-slot:item="{item, index, isExpanded, expand}">
                  <tr :class="{'employee-expanded': isExpanded}">
                    <td class="grapemp">
                      <v-icon :color="$vuetify.theme.themes[theme].text">drag_indicator</v-icon>
                    </td>
                    <td>{{ item.firstName }} {{ item.lastName }}</td>
                    <td>
                      <span v-for="(position , index) in positions" :key="index">
                        <span v-if="item.position == position.id"> {{ position.name}}</span>
                      </span>

                      <span v-if="item.startFunctionDate" style="padding: 0 0 0 5px; font-style: italic;">(vanaf {{ item.startFunctionDate.seconds | moment("D MMM YYYY") }})</span>
                    </td>
                    <td>
                      <span v-for="(employeeBranch , index) in item.branches" :key="index">
                        <span v-for="(branch, index) in branches" :key="index">
                          <div v-if="employeeBranch == branch.id"> {{ branch.branchName}}</div>
                        </span>
                      </span>
                    </td>
                    <td>
                      {{ item.age }}
                    </td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click="editEmployee(item)">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click="removeItemDialog(item, 'medewerker')">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">delete</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-btn icon @click="expand(true), setEmployeeBranchSchedule(item), selectedEmployeeIndex = index" v-if="!isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                      <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-item="{ headers, item }">
                  <td :colspan="headers.length" style="padding: 0;">
                    <v-card  flat background-color="menu" style="border-bottom: 1px solid;" :style="{borderColor: $vuetify.theme.themes[theme].menuborder}">
                      <v-card-text>
                        <v-container grid-list-md class="pa-0" fluid>
                          <v-layout row wrap>
                            <v-flex md4 xs12>
                              <v-select
                                :items="branches"
                                item-text="branchName"
                                item-value="id"
                                prepend-inner-icon="location_on"
                                v-model="item.selectedBranch"
                                label="Vestiging"
                                outlined
                                dense
                                v-on:input="setEmployeeBranchSchedule(item)"
                                hide-details
                                :color="companyPrimaryColor"
                                background-color="background"    
                                >
                              </v-select>
                            </v-flex>
                            <v-flex md8 xs12>
                              <div class="text-right">
                                <v-btn v-if="_.indexOf(item.branches, item.selectedBranch) >= 0" rounded :color="companySecondaryColor" class="modal-button-next" :dark="basicScheduleChanged" :disabled="!basicScheduleChanged" :depressed="!basicScheduleChanged" @click="saveBasicScheduleEmployee(item)">Wijzigingen opslaan<v-icon right dark>chevron_right</v-icon></v-btn>
                              </div>
                            </v-flex>
                          </v-layout>
                          <v-layout row wrap v-if="_.indexOf(item.branches, item.selectedBranch) >= 0">
                            <v-flex xs4>
                              <v-menu
                                ref="scheduleStartDateDialog"
                                :close-on-content-click="false"
                                v-model="scheduleStartDateDialog"
                                :nudge-right="40"         
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    clearable
                                    v-on="on"
                                    :value="scheduleStartDate.readable"
                                    label="Startdatum"
                                    prepend-inner-icon="today"
                                    readonly
                                    dense
                                    @click:clear="scheduleStartDateRaw = ''"
                                    outlined
                                    :hint="`${item.firstName } ${item.lastName } start met werken bij deze vestiging`"
                                    persistent-hint
                                    :color="companyPrimaryColor"
                                    class="mt-4"
                                    background-color="background"    
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  ref="picker"
                                  v-model="scheduleStartDateRaw"
                                  no-title
                                  color="primary"
                                  @input="scheduleStartDateDialog = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                            <v-flex xs4>
                              <v-menu
                                ref="scheduleEndDateDialog"
                                :close-on-content-click="false"
                                v-model="scheduleEndDateDialog"
                                :nudge-right="40"         
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                                min-width="290px"
                              >
                                <template v-slot:activator="{ on }">
                                  <v-text-field
                                    clearable
                                    v-on="on"
                                    class="mt-4"
                                    :value="scheduleEndDate.readable"
                                    label="Einddatum"
                                    prepend-inner-icon="today"
                                    @click:clear="scheduleEndDateRaw = ''"
                                    readonly
                                    dense
                                    outlined
                                    :hint="`${item.firstName } ${item.lastName } stopt met werken bij deze vestiging`"
                                    persistent-hint
                                    :color="companyPrimaryColor"
                                    background-color="background"    
                                  ></v-text-field>
                                </template>
                                <v-date-picker
                                  ref="picker"
                                  v-model="scheduleEndDateRaw"
                                  no-title
                                  color="primary"
                                  @input="scheduleEndDateDialog = false"
                                ></v-date-picker>
                              </v-menu>
                            </v-flex>
                          </v-layout>

                          <v-layout row wrap>
                            <v-flex xs12>
                              <div v-if="_.indexOf(item.branches, item.selectedBranch) >= 0">


                                <div v-show="!employeeBranchScheduleLoading">
                                  <h2 class="my-2">Basisrooster <span style="font-size: 16px!important;">({{ employeeBranchBasicScheduleHours }} uur)</span></h2>
                                  <v-alert v-if="!scheduleStartDate.formatted" class="pa-2 my-3" type="info" dense>
                                    <span class="white--text">Er is nog geen <strong>startdatum</strong> geselecteerd. Er kan nog niet afgesproken worden bij <strong>{{ item.firstName }} {{ item.lastName }}</strong> voor deze vestiging.</span>
                                  </v-alert>
                                      
                                  <div class="employee-calendar-wrapper">
                                    <FullCalendar
                                      ref="fullCalendarEmployee"
                                      :options="calendarOptions"
                                      selectConstraint="businessHours"
                                      eventConstraint="businessHours"
                                      :columnHeaderFormat="columnHeaderFormat"
                                      @eventDrop="eventResize"
                                      @eventClick="eventClick"
                                      @eventResize="eventResize"
                                      @select="select"
                                      :loading="calendarLoading"
                                    />
                                    <!-- <FullCalendar
                                      schedulerLicenseKey='GPL-My-Project-Is-Open-Source'
                                      ref="fullCalendarEmployee"
                                      timeZone="local"
                                      :disableResizing="false"
                                      :firstDay="0"
                                      defaultView="resourceTimeGridWeek"
                                      :slotLabelFormat="slotLabelFormat"
                                      scrollTime="00:60:00"
                                      :header="false"
                                      selectConstraint="businessHours"
                                      eventConstraint="businessHours"
                                      :eventStartEditable="true"
                                      :eventResourceEditable="false"
                                      :droppable="false"
                                      :editable="true"
                                      :selectOverlap="false"
                                      :allDaySlot="false"
                                      :slotEventOverlap="false"
                                      :eventOverlap="false"
                                      :selectable="true"
                                      :selectMirror="true"
                                      :businessHours="businessHours"
                                      :minTime="minTime"
                                      :maxTime="maxTime"
                                      :columnHeaderFormat="columnHeaderFormat"
                                      :eventBackgroundColor="companyPrimaryColor"
                                      :slotDuration="slotDuration"
                                      :plugins="calendarPlugins"
                                      :resources="resources"
                                      :resourceColumns="resourceColumns"
                                      :events="employeeBranchScheduleEvents"
                                      :eventResizableFromStart="eventResizableFromStart"
                                      contentHeight="680"
                                      @eventDrop="eventResize"
                                      @eventClick="eventClick"
                                      @eventResize="eventResize"
                                      @select="select"
                                    />  -->
                                  </div>
                                </div>
                                <div v-show="employeeBranchScheduleLoading">
                                  <div class="loading-dots">
                                    <div class="loading-dots-loader"></div>
                                    <p class="loading-dots-text"></p>
                                  </div>
                                </div>
                              </div>

                              <div v-else class="pa-4 text-center">
                                <v-icon small color="warning">warning</v-icon> <strong>Medewerker is niet actief bij deze vestiging.</strong>
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </td>
                </template>
              </v-data-table>
            </div>
            <div v-else class="not-found" >
              <div class="hipster-image" :class="randomHipster"></div>
              <p>Geen medewerkers met de naam <strong>{{ searchEmployees }}</strong> gevonden.</p>
            </div>
            
          </div>

          <div class="no-competention-data text-center" v-if="employeesLoaded && employees.length == 0">
            <p>Nog geen medewerkers toegevoegd</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">    
                  <v-btn fab darken color="primary" style="display: block; margin: 15px auto;" @click="addEmployee()">
                    <v-icon v-on="on" darken>add</v-icon>
                  </v-btn>
                </template>
                <span class="white--text">Voeg een nieuwe medewerker toe.</span>
              </v-tooltip>
          </div>
        </v-tab-item>
      
        <v-tab-item value="2" :transition="tabTransition" :reverse-transition="tabTransition">
          <div class="pa-4">
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex md8 xs12>
                  <h1 class="tab-title">Functies</h1>
                </v-flex>
                <v-flex md4 xs12>
                  <v-btn v-if="positionsLoaded && positions.length > 0" class="px-2 float-right" fab dark :color="companyPrimaryColor" @click="addPosition()">
                    <v-icon darken>add</v-icon>
                  </v-btn>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div v-if="positionsLoaded && positions.length > 0">
            <v-data-table
              :headers="headersPosition"
              :items="positions"
              item-key="index"
              hide-default-footer
              :itemsPerPage.sync="positionPages"
              >
              <template v-slot:item="{item}">
                <tr>
                  <td>{{ item.name }}</td>
                  <td>&euro; {{ item.revenue }} per uur</td>
                  <td>
                    <v-btn style="float: right;" icon class="mx-0" @click="editPosition(item)">
                      <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                    </v-btn>
                  </td>
                  <td>
                    <v-btn style="float: right;" icon class="mx-0" @click="removeItemDialog(item, 'functie')">
                      <v-icon small :color="$vuetify.theme.themes[theme].text">delete</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </div>

          <div class="no-competention-data text-center" v-if="positionsLoaded && positions.length == 0">
            <p>Nog geen functies toegevoegd</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">    
                <v-btn fab darken color="primary" style="display: block; margin: 15px auto;" @click="addPosition()">
                  <v-icon v-on="on" darken>add</v-icon>
                </v-btn>
                </template>
                <span class="white--text">Voeg een nieuwe functie toe.</span>
              </v-tooltip>
          </div>
        </v-tab-item>
      
        <v-tab-item value="3" :transition="tabTransition" :reverse-transition="tabTransition">
          <div class="pa-4">
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex md8 xs12>
                  <h1 class="tab-title">Kernactiviteiten</h1>
                </v-flex>
                <v-flex md4 xs12 >
                  <v-btn v-if="resultActivitiesLoaded" class="px-2" style="float: right" right fab dark :color="companyPrimaryColor" @click="addResultActivity()">
                    <v-icon darken>add</v-icon>
                  </v-btn>
                </v-flex> 
              </v-layout>
            </v-container>
          </div>

          <div v-show="resultActivitiesLoaded">
            <div v-for="(position, index) in positions" :key="index">
              <div class="px-4">
                <v-container grid-list-md class="pa-0" fluid>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <h2 class="tab-title">{{ position.name }}</h2>
                    </v-flex>
                  </v-layout>
                </v-container>
              </div>
              <div class="pb-4" v-show="resultActivitiesLoaded && position.resultActivities.length > 0" >
                <v-data-table
                  :key="resultActivitiesKey"
                  :headers="headersResultActivities"
                  :items="position.resultActivities"
                  hide-default-footer
                  :sort-by="['order']"
                  :itemsPerPage.sync="resultActivitiesPages"
                  :class="'table-' + position.id"
                  >
                  <template v-slot:item="{item, index, isExpanded, expand}">
                    <tr>
                      <td class="grap">
                        <v-icon :color="$vuetify.theme.themes[theme].text">drag_indicator</v-icon>
                      </td>
                      <td>{{ item.name }}</td>
                      <td>
                        <span v-for="(position , index) in positions" :key="index">
                          <span v-if="item.position == position.id">{{ position.name}}</span>
                        </span>
                      </td>
                      <td><span v-if="item.criteria">{{ item.criteria.length }}</span></td>
                      <td>
                        <v-btn style="float: right;" icon class="mx-0" @click="editResultActivity(item)">
                          <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                        </v-btn>
                      </td>
                      <td>
                        <v-btn style="float: right;" icon class="mx-0" @click="removeItemDialog(item, 'kernactiviteit')">
                          <v-icon small :color="$vuetify.theme.themes[theme].text">delete</v-icon>
                        </v-btn>
                      </td>
                      <td>
                        <v-btn icon @click="expand(true)" v-if="!isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                        <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                      </td>
                    </tr>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }">
                    <td :colspan="headers.length" style="padding: 0;">
                      <v-card  flat style="border-bottom: 1px solid rgba(0,0,0,0.12);" :style="{backgroundColor: $vuetify.theme.themes[theme].menuhover, borderColor: $vuetify.theme.themes[theme].menuborder}">
                        <v-card-text>
                          <b>Criteria</b>
                
                            <div v-for="(criterium, index) in item.criteria" :key="index">
                              <p class="ma-0">&#9679; <strong>{{ criterium.title }}</strong>
                              <p v-if="criterium.description " class="ma-0 pl-3">{{ criterium.description }}</p>
                            </div>
                        
                        </v-card-text>
                      </v-card>
                    </td>
                  </template>
                </v-data-table>
              </div>
              <div v-show="resultActivitiesLoaded && position.resultActivities.length == 0" class="pa-4" >
                <p><i>Geen kernactiviteiten</i></p>
              </div>
            </div>
          </div>

          <div v-if="!resultActivitiesLoaded" style="padding: 250px 0"> 
            <div class="blackbox-loader"></div>
          </div>

          <!-- <div class="no-competention-data text-center" v-if="resultActivitiesLoaded && resultActivities.length == 0">
            <p>Nog geen kernactiviteiten toegevoegd</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">    
                  <v-btn fab darken color="primary" style="display: block; margin: 15px auto;" @click="addResultActivity()">
                    <v-icon v-on="on" darken>add</v-icon>
                  </v-btn>
                </template>
                <span class="white--text">Voeg een nieuwe kernactiviteit toe.</span>
              </v-tooltip>
          </div> -->
        </v-tab-item>
      
        <v-tab-item value="4" :transition="tabTransition" :reverse-transition="tabTransition">
          <div class="pa-4">
            <v-container grid-list-md class="pa-0" fluid>
              <v-layout row wrap>
                <v-flex md8 xs12>
                  <h1 class="tab-title">Resultaatgebieden</h1>
                </v-flex>
                <v-flex md4 xs12>
                  <v-row v-if="resultAreasLoaded && resultAreas.length > 0">
                    <v-text-field
                      class="px-2"
                      v-model="searchResultAreas"
                      :color="companyPrimaryColor"
                      name="searchfield"
                      placeholder="Zoeken"
                      outlined
                      hide-details                                                     
                      prepend-inner-icon="search"
                      autocomplete="disabled"
                      clearable
                      backgroundColor="background"
                      single-line>
                    </v-text-field>
                    <v-btn class="px-2" fab dark :color="companyPrimaryColor" @click="addResultArea()">
                      <v-icon darken>add</v-icon>
                    </v-btn>
                  </v-row>
                </v-flex>
              </v-layout>
            </v-container>
          </div>

          <div v-if="resultAreasLoaded && resultAreas.length > 0">
            <div v-if="resultAreasFiltered.length > 0">
              <v-data-table
                :headers="headersResultAreas"
                :items="resultAreasFiltered"
                item-key="index"
                hide-default-footer
                :itemsPerPage.sync="resultaAreasPages"
                >        
                <template v-slot:item="{item}">
                  <tr>
                    <td>{{ item.name }}</td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click="editResultArea(item)">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">edit</v-icon>
                      </v-btn>
                    </td>
                    <td>
                      <v-btn style="float: right;" icon class="mx-0" @click="removeItemDialog(item, 'resultaatgebied')">
                        <v-icon small :color="$vuetify.theme.themes[theme].text">delete</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </div>
            <div v-else class="not-found" >
              <div class="hipster-image" :class="randomHipster"></div>
              <p>Geen resultaatgebieden met de naam <strong>{{ searchResultAreas }}</strong> gevonden.</p>
            </div>
          </div>

          <div class="no-competention-data text-center" v-if="resultAreasLoaded && resultAreas.length == 0">
            <p>Nog geen resultaatgebieden toegevoegd</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">    
                  <v-btn fab darken color="primary" style="display: block; margin: 15px auto;" @click="addResultArea()">
                    <v-icon v-on="on" darken>add</v-icon>
                  </v-btn>
                </template>
                <span class="white--text">Voeg een nieuwe resultaatgebied toe.</span>
              </v-tooltip>
          </div>
        </v-tab-item>
      </v-tabs-items>
    </div>

    <v-dialog hide-overlay v-model="removeDialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Uren verwijderen</v-card-title>
        <v-card-text>Verwijder de geselecteerde uren.</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-btn :color="companySecondaryColor" text @click="removeDialog = false, refreshCalendar()">Annuleren</v-btn>
          <v-spacer></v-spacer>
          <v-btn :color="companyPrimaryColor" dark @click="removeEvent()">Verwijderen</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
        
    <!-- / New Employee Dialog \-->
    <v-dialog v-model="newEmployeeDialog" max-width="600">
      <add-employee-form :activeCompData="activeCompData" :branches="branches" :positions="positions" @newEmployeeDialogChange="newEmployeeDialog = $event" @updateData="updateEmployeeData()"></add-employee-form>
    </v-dialog>
    <!-- \ New Employee Dialog / -->

    <!-- / Edit Employee Dialog \-->
    <v-dialog v-model="editEmployeeDialog" max-width="600">
      <edit-employee-form :activeCompData="activeCompData" :branches="branches" :selectedEmployeeItem="selectedEmployeeItem"  :selectedEmployeeItemOriginal="selectedEmployeeItemOriginal"  :positions="positions" @editEmployeeDialogChange="editEmployeeDialog = $event" @updateData="updateEmployeeData()"></edit-employee-form>
    </v-dialog>
    <!-- \ Edit Employee Dialog / -->

    <!-- / New Position Dialog \-->
    <v-dialog v-model="newPositionDialog" scrollable max-width="600">
      <add-position-form :activeCompData="activeCompData" @newPositionDialogChange="newPositionDialog = $event" @updateData="updatePositionData()"></add-position-form>
    </v-dialog>
    <!-- \ New Position Dialog / -->

    <!-- / Edit Position Dialog \-->
    <v-dialog v-model="editPositionDialog" scrollable max-width="600">
      <edit-position-form :activeCompData="activeCompData" :selectedPositionItem="selectedPositionItem"  :selectedPositionItemOriginal="selectedPositionItemOriginal" @editPositionDialogChange="editPositionDialog = $event" @updateData="updatePositionData()"></edit-position-form>
    </v-dialog>
    <!-- \ Edit Position Dialog / -->

    <!-- / New Result Area Dialog \ -->
    <v-dialog v-model="newResultAreaDialog" scrollable max-width="600">
      <add-resultarea-form :activeCompData="activeCompData" @newResultAreaDialogChange="newResultAreaDialog = $event" @updateData="updateResultAreaData()"></add-resultarea-form>
    </v-dialog>
    <!-- \ New Result Area  Dialog / -->

    <!-- / Edit Result Area  Dialog \-->
    <v-dialog v-model="editResultAreaDialog" scrollable max-width="600">
      <edit-resultarea-form :activeCompData="activeCompData" :selectedResultAreaItem="selectedResultAreaItem" :selectedResultAreaItemOriginal="selectedResultAreaItemOriginal" @editResultAreaDialogChange="editResultAreaDialog = $event" @updateData="updateResultAreaData()"></edit-resultarea-form>
    </v-dialog>
    <!-- \ Edit Result Area  Dialog / -->

    <!-- / New Result Area Dialog \ -->
    <v-dialog v-model="newResultActivityDialog" scrollable max-width="600">
      <add-resultactivity-form :activeCompData="activeCompData" :resultActivityItems="resultActivityItems"  :positions="positions" :resultAreas="resultAreas" @newResultActivityDialogChange="newResultActivityDialog = $event" @updateData="updateResultActivityData()"></add-resultactivity-form>
    </v-dialog>
    <!-- \ New Result Area  Dialog / -->

    <!-- / Edit Result Area  Dialog \-->
    <v-dialog v-model="editResultActivityDialog" scrollable max-width="600">
      <edit-resultactivity-form :activeCompData="activeCompData" :positions="positions" :resultAreas="resultAreas" :selectedResultActivityItem="selectedResultActivityItem" :selectedResultActivityItemOriginal="selectedResultActivityItemOriginal" @editResultActivityDialogChange="editResultActivityDialog = $event" @updateData="updateResultActivityData()"></edit-resultactivity-form>
    </v-dialog>
    <!-- \ Edit Result Area  Dialog / -->

    <!-- / Delete Dialog \-->
    <v-dialog v-model="removeItemData.dialog" max-width="450">
      <v-card>
        <v-card-title class="pr-2" :style=" { backgroundColor: companyPrimaryColor }">
          <h2 class="white--text"><span class="white--text" style="text-transform: capitalize;">{{ removeItemData.type }}</span> verwijderen</h2>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="removeItemData.dialog = false">
            <v-icon dark color="white">close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <div class="pt-4"><span style="text-transform: capitalize;">{{ removeItemData.type }}</span> definitief verwijderen?</div>
        </v-card-text>
        
        <v-divider></v-divider>

        <v-card-actions>
          <v-container grid-list-md fluid class="ma-0 pa-0">
            <v-layout row wrap class="ma-0 pa-0">
              <v-flex xs12 md6 class="text-left" v-if="$vuetify.breakpoint.name != 'sm' && $vuetify.breakpoint.name != 'xs'">
                <v-btn
                  outlined
                  depressed
                  color="#8B93A6"
                  @click="removeItemData.dialog = false"
                  >
                  Annuleren
                </v-btn>
              </v-flex>
              <v-flex xs12 md6 class="text-right">
                <v-btn
                  dark
                  rounded
                  :block="$vuetify.breakpoint.name == 'sm' || $vuetify.breakpoint.name == 'xs'"
                  :color="companySecondaryColor"
                  @click="removeItem()"
                  >
                  Verwijderen
                  <v-icon right dark>chevron_right</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-actions>

      </v-card>
    </v-dialog>
    <!-- \ Delete Dialog / -->

    <v-snackbar
      v-model="snackbar.active"
      :color="snackbar.color"
      top
      :timeout="snackbar.timeout"
      >
      <v-row>
        <v-icon color="white" class="mx-3">{{ snackbar.icon}}</v-icon>
        <span class="py-2 white--text">{{ snackbar.text}}</span>
      </v-row>
    </v-snackbar>

  </div>
</template>


<script>
import Vue from "vue";
import { bus } from "../main";
import db from "../firebase/init";
import platform from 'platform'; 
import { Chrome } from "vue-color";
import moment from "moment";
import Sortable from "sortablejs";
import draggable from "vuedraggable";

import AddPositionForm from "../components/modals/AddPositionForm.vue";
import EditPositionForm from "../components/modals/EditPositionForm.vue";
import AddEmployeeForm from "../components/modals/AddEmployeeCompForm.vue";
import EditEmployeeForm from "../components/modals/EditEmployeeCompForm.vue";
import AddResultAreaForm from "../components/modals/AddResultAreaForm.vue";
import EditResultAreaForm from "../components/modals/EditResultAreaForm.vue";
import AddResultActivityForm from "../components/modals/AddResultActivityForm.vue";
import EditResultActivityForm from "../components/modals/EditResultActivityForm.vue";


//Full Calendar 
  import FullCalendar from "@fullcalendar/vue";
  import dayGridPlugin from "@fullcalendar/daygrid";
  import scrollgrid from "@fullcalendar/scrollgrid";
  import interactionPlugin from "@fullcalendar/interaction";
  import resourceTimeGridPlugin from "@fullcalendar/resource-timegrid";

// import FullCalendar from '@fullcalendar/vue'
// import resourceTimelinePlugin from '@fullcalendar/resource-timeline'
// import resourceTimeGridPlugin from '@fullcalendar/resource-timegrid';
// import dayGridPlugin from '@fullcalendar/daygrid'
// import interactionPlugin, { Draggable } from '@fullcalendar/interaction';
// import NL from '@fullcalendar/core/locales/nl';

// import "@fullcalendar/core/main.css";
// import "@fullcalendar/daygrid/main.css";
// import "@fullcalendar/timegrid/main.css";

export default {
  name: "CompetenieSettings",
  components: {
    FullCalendar,
    "chrome-picker": Chrome,
    "add-position-form": AddPositionForm,
    "edit-position-form": EditPositionForm,
    "add-employee-form": AddEmployeeForm,
    "edit-employee-form": EditEmployeeForm,
    "add-resultarea-form": AddResultAreaForm,
    "edit-resultarea-form": EditResultAreaForm,
    "add-resultactivity-form": AddResultActivityForm,
    "edit-resultactivity-form": EditResultActivityForm
  },


  data () {
    return {

    // Calendar Settings

    calendarOptions: {
      plugins: [dayGridPlugin, interactionPlugin, resourceTimeGridPlugin, scrollgrid],
      initialView: "resourceTimeGridWeek",
        dayMinWidth: 135,
        headerToolbar: {
          left: "prev,next today",
          center: "title",
          right: "resourceTimeGridWeek",
        },
        businessHours: {
          daysOfWeek: [0, 1, 2, 3, 4, 5, 6],
          startTime: "07:00",
          endTime: "23:59",
        },
        slotLabelFormat: {
          hour: "numeric",
          minute: "2-digit",
          omitZeroMinute: false,
          meridiem: false,
          hour12: false,
        },
        calendarView: 'day',
        firstDay: 1,
        titleFormat: { year: "numeric", month: "2-digit", day: "2-digit" },
        schedulerLicenseKey: "GPL-My-Project-Is-Open-Source",
        slotMinTime: "07:00:00",
        slotMaxTime: "23:59:00",
        slotDuration: "00:30:00",
        contentHeight: "auto",
        slotEventOverlap: false,
        eventTextColor: "#000000",
        eventBorderColor: "#1f89e5",
        eventOverlap: false,
        selectOverlap: false,
        dayMaxEvents: true,
        weekends: true,
        selectable: true,
        selectMirror: true,
        eventStartEditable: true,
        eventDurationEditable: true,
        eventResizableFromStart: true,
        eventResourceEditable: false,
        refetchResourcesOnNavigate: true,
        droppable: false,

        dayHeaderFormat: { weekday: "long" },
        displayEventTime: true,
        resourceOrder: 'order',
        eventResizableFromStart: false,
        timeZone: "local",
        locale: "NL",
        allDaySlot: false,
        resources: new Array(),
        initialEvents: this.fetchEvents,
        loading: this.isLoading,
        eventResize: (eventData) => {
          return this.eventResize(eventData);
        },
        eventDrop: (eventData) => {
          return this.eventResize(eventData);
        },
        eventClick: (eventData) => {
          return this.eventClick(eventData);
        },
        select: (eventData) => {
          return this.select(eventData);
        },
    },

    
    
    minTime: "7:00",
    maxTime: "22:00",
    slotDuration: '00:30:00',
    allDaySlot: false,
    slotLabelFormat:{
      hour: 'numeric',
      minute: '2-digit',
      omitZeroMinute: false,
      meridiem: false,
      hour12:false
    },
    columnHeaderFormat: { weekday: 'long' },
    resourceColumns: [

    ],

    eventResizableFromStart: true,
    businessHours: {
      daysOfWeek: [ 0, 1, 2, 3, 4, 5 ,6 ], 
      startTime: '7:00', 
      endTime: '22:00', 
    },
    calendar: null,
    resources: [
      {
        title: null,
        id: null
      }
    ],

    snackbar: {
      active: false,
      text: "",
      icon: "",
      timeout: -1,
      color: "",
    },

    resultActivitiesOptions: {
      sortBy: 'order',
      sortDesc: false
    },

    removeDialog: false,
    selectedEmployeeIndex: null,
    employeeBranchScheduleLoading: true,
    employeeBranchScheduleEvents: [],
    employeeBranchScheduleEventsOriginal: [],
    scheduleStartDateRaw: null,
    scheduleStartDateDialog: false,
    scheduleEndDateRaw: null,
    scheduleEndDateDialog: false,

    loading: true,
    feedback: null,
    activeComp: "",
    activeCompData: {},
    activeCompDataOriginal: {},
    positions: [],
    employees: [],
    employeesOriginal: [],
    resultAreas: [],
    resultActivities: [],
    searchCompanies: "",
    employeesPages: -1,
    resultaAreasPages: -1,
    resultActivitiesPages: -1,
    positionPages: -1,
    tabTransition: false,
    tab: "3",
    newPositionDialog: false,
    editPositionDialog: false,
    newEmployeeDialog: false,
    editEmployeeDialog: false,
    newResultAreaDialog: false,
    editResultAreaDialog: false,
    newResultActivityDialog: false,
    editResultActivityDialog: false,

    positionsLoaded: false,
    employeesLoaded: false,
    resultActivitiesLoaded: false,
    resultAreasLoaded: false,

    searchEmployees: "",
    searchResultActivities: "",
    searchResultAreas: "",
    selectedPositionItemOriginal: {},
    selectedPositionItem: {
      name:null,
      revenue: null
    },
    selectedResultAreaItemOriginal: {},
    selectedResultAreaItem: {
      name: null
    },
    selectedEvent: null,

    removeItemData: {
      dialog: false,
      type: null,
      data: {}
    },
    selectedResultActivityItemOriginal: {},
    selectedResultActivityItem: {
      name: null,
      area: null,
      cirteria: []
    },
    selectedEmployeeItemOriginal: {},

    selectedEmployeeItem: {
      firstName:null,
      lastName: null,
      position: null,
      startFunctionDateRaw: null,
      birthdayDateRaw: null,
    },
    resultActivitiesKey: 21,

    branches:[],

    resultActivityItems: {},
    watcher: 44,

    headersResultAreas: [
      {
        text: "Naam",
        align: "left",
        value: "name"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      }
    ],
    headersResultActivities: [
      {
        text: "",
        align: "right",
        value: "",
        sortable: false,
        width: "30px"
      },
      {
        text: "Naam",
        align: "left",
        value: "name"
      },
      {
        text: "Functie",
        align: "left",
        value: "order",
        width: "250px",
        sortable: false
      },
      {
        text: "Aantal criteria",
        align: "left",
        value: "criteria.length",
        width: "200px",
        sortable: false
      },
      {
        text: "",
        align: "right",
        value: "index",
        width: "50px",
        sortable: false
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px",
        sortable: false
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px",
        sortable: false
      }
    ],

    headersPosition: [
      {
        text: "Naam",
        align: "left",
        value: "name"
      },
      {
        text: "Omzet per uur",
        align: "left",
        value: "revenue"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      }
    ],

    headersEmployee: [
      {
        text: "",
        align: "right",
        value: "",
        sortable: false,
        width: "30px"
      },
      {
        text: "Naam",
        align: "left",
        value: "firstName"
      },
      {
        text: "Functie",
        align: "left",
        value: "position"
      },
      {
        text: "Salons",
        align: "left",
        value: "branches"
      },
      {
        text: "Leeftijd",
        align: "left",
        value: "age"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      },
      {
        text: "",
        align: "right",
        value: "",
        width: "50px"
      },{
        text: "",
        align: "right",
        value: "",
        width: "50px"
      }
    ],
  }},

  created() {
    this.loadUserComp();
  },

  methods: {

    // SELECT EVENT
    eventClick(info) {
      this.removeDialog = true
      this.selectedEvent = info.event
      info.el.style.backgroundColor = this.companyPrimaryColor;
    },

    async fetchEvents() {
      return this.employeeBranchScheduleEvents;
    },

    removeEvent(){
      let counter = 0;
      let removeIndex;
      new Promise(resolve=>{
         this.employeeBranchScheduleEvents.forEach((event, index)=>{
           if(event.id == this.selectedEvent.id){
             removeIndex = index  
           }
           counter++
           if(counter == this.employeeBranchScheduleEvents.length){
             resolve()
           }
         })
      })
      .then(()=>{
        this.employeeBranchScheduleEvents.splice(removeIndex,1)
        this.removeDialog = false
        this.refreshCalendar();
      })
    },

    calendarLoading() {
      return this.loading || this.calendarChecking ? true : false;
    },

    setEmployeeBranchSchedule(employee){
      this.employeeBranchScheduleLoading = true;
      this.employeeBranchScheduleEvents = [];
      this.resources[0].title = employee.firstName + " " + employee.lastName;
      this.resources[0].id = employee.id;
      let counter = 0;
      this.calendarOptions.resources = this.resources;
      if(employee.basicSchedule[employee.selectedBranch]){
        new Promise(resolve =>{
          const days = Object.keys(employee.basicSchedule[employee.selectedBranch])
          for (const day of days) {
            let dayOfWeek = 0;
            if(day == 'mon'){ dayOfWeek = 1};
            if(day == 'tue'){ dayOfWeek = 2};
            if(day == 'wed'){ dayOfWeek = 3};
            if(day == 'thu'){ dayOfWeek = 4};
            if(day == 'fri'){ dayOfWeek = 5};
            if(day == 'sat'){ dayOfWeek = 6};


            if(employee.basicSchedule[employee.selectedBranch][day] && employee.basicSchedule[employee.selectedBranch][day].length > 0){
              employee.basicSchedule[employee.selectedBranch][day].forEach(item=> {
                let event = {
                  day: dayOfWeek,
                  id: this.employeeBranchScheduleEvents.length,
                  resourceId: employee.id, 
                  start: moment().day(dayOfWeek).format("YYYY-MM-DD") + "T" + item.start,
                  end: moment().day(dayOfWeek).format("YYYY-MM-DD") + "T" + item.end,
                  color: '#eeeeee',
                }
                this.employeeBranchScheduleEvents.push(event)
              })
              counter++
              if(counter == days.length){
                this.employeeBranchScheduleEventsOriginal = _.cloneDeep(this.employeeBranchScheduleEvents)
                resolve()
              }
            } else{
              
              counter++
              if(counter == days.length){
                resolve()
              }
            }
          }
        })
        .then(()=>{ 
          this.employeeBranchScheduleLoading = false;    
          setTimeout(() => {
            this.refreshCalendar();
          }, 100);

        })        
      }
      else{
        this.employeeBranchScheduleLoading = false;
         setTimeout(() => {
            this.refreshCalendar();
        }, 100);
      }
    },

     // NIEUWE EVENT op basis van slepen in de calendar
    select(info){
      let resourceId = info.resource.id;
      let mergeAvailable = false;
      let mergeEventIndexBefore;
      let mergeEventIndexAfter;
      let mergeTypeBefore = false;
      let mergeTypeAfter = false;
      let selectedDate = moment(info.start).format("YYYY-MM-DD");
      let start = moment(info.start).format("YYYY-MM-DD"+"T"+"HH:mm");
      let end = moment(info.end).format("YYYY-MM-DD"+"T"+"HH:mm");
      let counter = 0;
      let event = {
            id: this.employeeBranchScheduleEvents.length + "new",
            day: String(moment(selectedDate).day()).toLowerCase(),
            resourceId: info.resource.id,
            start: start,
            end: end,
            color: "#eeeeee"
          };

      if(this.employeeBranchScheduleEvents.length > 0){
        new Promise((resolve)=>{
          this.employeeBranchScheduleEvents.forEach((event, index)=>{
            if(event.resourceId == resourceId){
              this.employeeBranchScheduleEvents[index].color = "#eeeeee";
            }
            if(event.resourceId == resourceId && event.start == end){
              mergeAvailable = true;
              mergeTypeBefore = true;
              mergeEventIndexBefore = index
            }
            if(event.resourceId == resourceId && event.end == start){
              mergeAvailable = true;
              mergeTypeAfter = true;
              mergeEventIndexAfter = index;
            }
            counter++
            if(counter == this.employeeBranchScheduleEvents.length){
              resolve()
            }
          })
        })
        .then(()=>{
          if(mergeAvailable){
            if(mergeTypeBefore && mergeTypeAfter){
              this.employeeBranchScheduleEvents[mergeEventIndexAfter].end = this.employeeBranchScheduleEvents[mergeEventIndexBefore].end;
              this.employeeBranchScheduleEvents[mergeEventIndexAfter].color = "#eeeeee";
              this.employeeBranchScheduleEvents.splice(mergeEventIndexBefore,1)
            }
            else if(mergeTypeBefore && !mergeTypeAfter){
              this.employeeBranchScheduleEvents[mergeEventIndexBefore].start = start;
              this.employeeBranchScheduleEvents[mergeEventIndexBefore].color = "#eeeeee";
            }
            else if(!mergeTypeBefore && mergeTypeAfter) {
              this.employeeBranchScheduleEvents[mergeEventIndexAfter].end = end;
              this.employeeBranchScheduleEvents[mergeEventIndexAfter].color = "#eeeeee";
            }
          }
          else{
            this.employeeBranchScheduleEvents.push(event);
          }
        })
        .then(()=>{
          this.calendar.unselect();
          this.refreshCalendar();
        })
      } 
      else{
        this.employeeBranchScheduleEvents.push(event);
        this.calendar.unselect();
        this.refreshCalendar();
      }
    },

    saveBasicScheduleEmployee(item){
      // Save new basic schedule of branch to employee
      let counter = 0;
      let schedule = {
        startDate: this.scheduleStartDate.firebase,
        endDate: this.scheduleEndDate.firebase,
        basicScheduleLastChanged: new Date(),
        sun: [],
        mon: [],
        tue: [],
        wed: [],
        thu: [],
        fri: [],
        sat: []
      }

      new Promise(resolve=>{
        this.employeeBranchScheduleEvents.forEach(event=>{
          let dayOfWeek = 'sun'
          if(event.day == '1'){ dayOfWeek = 'mon'};
          if(event.day == '2'){ dayOfWeek = 'tue'};
          if(event.day == '3'){ dayOfWeek = 'wed'};
          if(event.day == '4'){ dayOfWeek = 'thu'};
          if(event.day == '5'){ dayOfWeek = 'fri'};
          if(event.day == '6'){ dayOfWeek = 'sat'};
          schedule[dayOfWeek].push({
            start: moment(event.start).format("HH:mm"),
            end: moment(event.end).format("HH:mm"),
          })
          schedule[dayOfWeek] = _.orderBy(schedule[dayOfWeek], ['start'],['asc']);
          counter++
          if(counter == this.employeeBranchScheduleEvents.length){
            resolve()
          } 
        })
      })
      .then(()=>{
        let basicSchedule = _.cloneDeep(item.basicSchedule);
        basicSchedule[item.selectedBranch] = schedule;

        db.collection("employees")
          .doc(item.id)
          .set({
            basicSchedule: basicSchedule,
          }, { merge: true })
          .catch(error => {
            console.error("Error updating basic schedule employee: ", error);
          })
      })

      .then(()=>{
        let previousDate = null;
        if(item.basicSchedule[item.selectedBranch].basicScheduleLastChanged){
          previousDate = moment.unix(item.basicSchedule[item.selectedBranch].basicScheduleLastChanged.seconds).format("YYYY/MM/DD");
        }
        else if(this.scheduleStartDate.formatted){
          previousDate = this.scheduleStartDate.formatted;
        }
        return previousDate
      })
      .then(previousDate=>{       
        if(previousDate){
          // Aantal weken berekenen tussen
          let today = moment()
          let weekNumberPreviousDate = moment(previousDate, "YYYY/MM/DD").week();
          let yearPreviousDate = moment(previousDate, "YYYY/MM/DD").year();
          let currentWeekNumber = moment().week();
          let currentYear = moment().year();
          let weeksBetween = today.diff(previousDate, 'weeks')

          if(weeksBetween > 0){
            let activeWeeks = Array.apply(null, Array(weeksBetween))
            let weekCounter = weekNumberPreviousDate;
            let yearCounter = yearPreviousDate;
            let counter = 0;
            new Promise(resolve=>{
              activeWeeks.forEach((week, index)=>{
                if(weekCounter == 52){
                  weekCounter = 0;
                  yearCounter++
                }
                weekCounter++
                activeWeeks[index] = {
                  year: yearCounter,
                  week: weekCounter
                }
                counter++
                if(counter == activeWeeks.length){
                  resolve();
                }
              })
            })
            .then(()=>{
              let oldBasicSchedules = [];
              // Database Schedules updaten
              console.log("activeWeeks: ", activeWeeks)
              let docCounter = 0;
              new Promise(resolve=>{
                activeWeeks.forEach((week)=>{
                db.collection("schedules")
                  .where("compId", "==", this.activeCompData.id)
                  .where("branchId", "==", item.selectedBranch)
                  .where("year", "==", week.year)
                  .where("week", "==", week.week)
                  .where("employeeId", "==", item.id)
                  .get()
                  .then(snap => {
                    if(snap.size == 0){
                      oldBasicSchedules.push(week);
                    }
                    docCounter++
                    if(docCounter == activeWeeks.length){
                      resolve();
                    } 
                  })
                })
              })
              .then(()=>{
                if(oldBasicSchedules.length > 0){
                  console.log("oldBasicSchedules", oldBasicSchedules)
                  let newDocCounter = 0;
                  let schedule = {
                    sun: item.basicSchedule[item.selectedBranch].sun,
                    mon: item.basicSchedule[item.selectedBranch].mon,
                    tue: item.basicSchedule[item.selectedBranch].tue,
                    wed: item.basicSchedule[item.selectedBranch].wed,
                    thu: item.basicSchedule[item.selectedBranch].thu,
                    fri: item.basicSchedule[item.selectedBranch].fri,
                    sat: item.basicSchedule[item.selectedBranch].sat,
                  }
                  new Promise(resolve=>{
                    oldBasicSchedules.forEach(week=>{
                      db.collection("schedules")
                        .doc()
                        .set({
                          compId: this.activeCompData.id,
                          branchId: item.selectedBranch,
                          employeeId: item.id,
                          week: week.week,
                          year: week.year,
                          schedule: schedule
                        }, { merge: true })
                        .then(()=>{
                          //console.log("Nieuw database document aangemaakt")
                          newDocCounter++
                          if(newDocCounter == oldBasicSchedules.length){
                            resolve()
                          }
                        })
                        .catch(error => {
                          newDocCounter++
                          if(newDocCounter == oldBasicSchedules.length){
                            resolve()
                          }
                          console.error("Error updating schedules: ", error);
                        })
                      })
                  })
                  .then(()=>{
                    console.log("Alles is geupdated")
                    this.snackbar.active = true;
                    this.snackbar.timeout = 3000;
                    this.snackbar.color = "rgba(1, 230, 110, 0.7)";
                    this.snackbar.icon = "thumb_up";
                    this.snackbar.text = "Basisplanning succesvol aangepast."; 
                  })
                } else{
                  console.log("Niets te updaten") 
                  this.snackbar.active = true;
                  this.snackbar.timeout = 3000;
                  this.snackbar.color = "rgba(1, 230, 110, 0.7)";
                  this.snackbar.icon = "thumb_up";
                  this.snackbar.text = "Basisplanning succesvol aangepast.";
                }
              })
            })
          } 
          else{
            console.log("Zelfde week nog gewijzigd")
            this.snackbar.active = true;
            this.snackbar.timeout = 3000;
            this.snackbar.color = "rgba(1, 230, 110, 0.7)";
            this.snackbar.icon = "thumb_up";
            this.snackbar.text = "Basisplanning succesvol aangepast.";
          }
        }
        
      })
      
      // Check all week and years between last change of basic schedule and update

      // No startdate? No updating needed;

      console.log("item: ", item)
    },

    refreshCalendar() {
      this.calendar = this.$refs.fullCalendarEmployee.getApi();
      // this.calendar.setOption('locale', NL);
      this.calendar.refetchEvents();
      this.calendar.refetchResources();
    },

    // RESIZE OF VERPLAATSEN EVENT 
    eventResize(info) { 
      let resources = info.event.getResources();
      let resourceId = resources[0].id;
      let mergeAvailable = false;
      let mergeTypeAfter = false;
      let mergeTypeBefore = false;
      let selectedEventIndex
      let mergeEventIndexBefore
      let mergeEventIndexAfter
      let mergeType
      let start = moment(info.event.start).format("YYYY-MM-DD"+"T"+"HH:mm");
      let end = moment(info.event.end).format("YYYY-MM-DD"+"T"+"HH:mm");
      let counter = 0
      new Promise((resolve)=>{
        this.employeeBranchScheduleEvents.forEach((event, index)=>{
          if(event.resourceId == resourceId){
            this.employeeBranchScheduleEvents[index].color = "#eeeeee";
          }
          if(info.event.id == event.id){
            selectedEventIndex = index;
          }
          if(event.resourceId == resourceId && event.start == end && index !== selectedEventIndex){
            mergeAvailable = true;
            mergeTypeBefore = true;
            mergeEventIndexBefore = index;
          }
          if(event.resourceId == resourceId && event.end == start && index !== selectedEventIndex){
            mergeAvailable = true;
            mergeTypeAfter = true;
            mergeEventIndexAfter = index;
          }
          counter++
          if(counter == this.employeeBranchScheduleEvents.length){
            resolve()
          }
        })
      })
      .then(()=>{
        if(mergeAvailable){
          if(mergeTypeBefore && mergeTypeAfter){
            this.employeeBranchScheduleEvents[mergeEventIndexAfter].end = this.employeeBranchScheduleEvents[mergeEventIndexBefore].end;
            this.employeeBranchScheduleEvents[mergeEventIndexAfter].color = "#eeeeee";
            this.employeeBranchScheduleEvents.splice(selectedEventIndex,1)
            this.employeeBranchScheduleEvents.splice(mergeEventIndexBefore,1)
          }
          else if(mergeTypeBefore && !mergeTypeAfter){
            this.employeeBranchScheduleEvents[mergeEventIndexBefore].start = start;
            this.employeeBranchScheduleEvents[mergeEventIndexBefore].color = "#eeeeee";
            this.employeeBranchScheduleEvents.splice(selectedEventIndex,1)
          }
          else if(!mergeTypeBefore && mergeTypeAfter) {
            this.employeeBranchScheduleEvents[mergeEventIndexAfter].end = end;
            this.employeeBranchScheduleEvents[mergeEventIndexAfter].color = "#eeeeee";
            this.employeeBranchScheduleEvents.splice(selectedEventIndex,1)
          }
        }
        else{
          this.employeeBranchScheduleEvents[selectedEventIndex].start = start;
          this.employeeBranchScheduleEvents[selectedEventIndex].end = end;
          this.employeeBranchScheduleEvents[selectedEventIndex].color = "#eeeeee"
        }
      })
      .then(()=>{
        this.refreshCalendar();
      })
    },

    loadBranches(){
      db.collection("branches")
        .where('compId',"==", this.activeCompData.id)
        .get()
        .then(snap => {
          this.branches = [];
          snap.forEach(doc => {
            let branch = doc.data();
            branch.id = doc.id;
            this.branches.push(branch);
          });
        })
        .catch(error =>{
          console.error("Error loading branches: ", error)
        })
    },

    loadPositions(){
       this.resultActivitiesLoaded = false;
      db.collection("positions")
        .where('compId',"==", this.activeCompData.id)
        .where('deleted.deleted',"==", false)
        .get()
        .then(snap => {
          this.positions = [];
          snap.forEach(doc => {
            let position = doc.data();
            position.id = doc.id;
            position.resultActivities = [];
            this.positions.push(position);
          });
        })
        .then(()=>{
          this.positionsLoaded = true;
          this.loadResultActivities();
        })
    },

    loadEmployees(){
      db.collection("employees")
        .where('companyId',"==", this.activeCompData.id)
        .where('deleted.deleted',"==", false)
        .get()
        .then(snap => {
          this.employees = [];
          snap.forEach(doc => {
            let employee = doc.data();
            employee.id = doc.id;
            employee.selectedBranch = null;
            if(employee.branches && employee.branches.length > 0){
              employee.selectedBranch = employee.branches[0]
            }
            if(employee.birthdayDate != null){
              let today = moment()
              let birthday = moment.unix(employee.birthdayDate.seconds)
              employee.age = moment.duration(today.diff(birthday)).years();
            } else{
              employee.age = '-'
            }
            this.employees.push(employee);
          });
        })
        .then(()=>{
          this.employeesOriginal = _.cloneDeep(this.employees);
          this.employeesLoaded = true;
        })
    },

    showEmployees(){
      setTimeout(()=>{
        this.employees.sort(this.sortEmployees);
        this.orderEmployees();
      }, 100)
      
    },

    loadResultAreas(){
      db.collection("resultAreas")
        .where('compId',"==", this.activeCompData.id)
        .where('deleted.deleted',"==", false)
        .get()
        .then(snap => {
          this.resultAreas = [];
          snap.forEach(doc => {
            let resultArea = doc.data();
            resultArea.id = doc.id;
            this.resultAreas.push(resultArea);
          });
        })
        .then(()=>{
          this.resultAreasLoaded = true
        })
    },

    loadResultActivities(){
      let counter = 0;
      new Promise((resolve)=>{
        if(this.positions.length > 0){
          this.positions.forEach((position, index)=>{
            db.collection("resultActivities")
            .where('compId',"==", this.activeCompData.id)
            .where('position',"==", position.id)
            .where('deleted.deleted',"==", false)
            .orderBy("order")
            .get()
            .then(snap => {
              this.positions[index].resultActivities = [];
              snap.forEach(doc => {
                let resultActivity = doc.data();
                resultActivity.id = doc.id;
                this.positions[index].resultActivities.push(resultActivity);
              });
            })
            .then(()=>{
              
              if (this.positions[index].resultActivities.length > 0) {
                this.positions[index].resultActivities.sort(this.sortActivities);
                this.resultActivityItems[position.id] = this.positions[index].resultActivities.length;
              }
              else{
                this.resultActivityItems[position.id] = 0;
              }
              counter++
              if(counter == this.positions.length){
                resolve();
              }
            })
          })
        }
        else{
          resolve();
        }
      })
      .then(()=>{
        this.resultActivitiesLoaded = true;
        this.orderActivities();
      })
    },

    sortActivities(a, b) {
      // Use toUpperCase() to ignore character casing
      const genreA = a.order;
      const genreB = b.order;

      let comparison = 0;
      if (genreA > genreB) {
        comparison = 1;
      } else if (genreA < genreB) {
        comparison = -1;
      }
      return comparison;
    },

    orderActivities() {
      this.positions.forEach((position, index)=>{
        let className = ".table-" + position.id + " tbody";
        let element = document.querySelector(className);
        const vm = this;
        Sortable.create(element, {
          handle: ".grap",
          onEnd({ newIndex, oldIndex }) {
            const rowSelected = vm.positions[index].resultActivities.splice(oldIndex, 1)[0]; // Get the selected row and remove it
            vm.positions[index].resultActivities.splice(newIndex, 0, rowSelected); // Move it to the new index
            vm.updateActivities(vm.positions[index].resultActivities);
          }
        });
      });
    },

    updateActivities(activities) {
      let counter = 0;
      new Promise((resolve)=>{
        activities.forEach(item => {
          let numberItem = activities.indexOf(item);
          item.order = activities.indexOf(item);
          // console.log("Update Question Order: " + item.order + " wordt ArrayIndex: " + numberItem);
          db.collection("resultActivities")
            .doc(item.id)
            .set({
              order: numberItem
            },{merge: true})
            counter++
            if(counter == activities.length){
              resolve();
            }
        });
      })
      .then(()=>{
        this.resultActivitiesKey = this.resultActivitiesKey + 1;
        setTimeout(()=> { 
          this.orderActivities(); 
        }, 500);
      })
      
      
    },

    updatePositionData(){
      this.loadPositions();
    },

    updateEmployeeData(){
      this.loadEmployees();
    },

    updateResultAreaData(){
      this.loadResultAreas();
    },

    updateResultActivityData(){
      this.loadPositions();
    },

    addPosition(){
      this.newPositionDialog = true
    },

    editPosition(item){
      this.selectedPositionItem = _.cloneDeep(item)
      this.selectedPositionItemOriginal = _.cloneDeep(item)
      this.editPositionDialog = true
    },

    addEmployee(){
      this.newEmployeeDialog = true
    },

    editEmployee(item){
      this.selectedEmployeeItem = _.cloneDeep(item)
      this.selectedEmployeeItem.functionStartDateRaw = null
      this.selectedEmployeeItem.functionEndDateRaw = null
      this.selectedEmployeeItem.birthdayDateRaw = null

      if(this.selectedEmployeeItem.startFunctionDate){
        this.selectedEmployeeItem.functionStartDateRaw = moment.unix(this.selectedEmployeeItem.startFunctionDate.seconds).format("YYYY-MM-DD")
      }
      if(this.selectedEmployeeItem.endFunctionDate){
        this.selectedEmployeeItem.functionEndDateRaw = moment.unix(this.selectedEmployeeItem.endFunctionDate.seconds).format("YYYY-MM-DD")
      }

      if(this.selectedEmployeeItem.birthdayDate){
        this.selectedEmployeeItem.birthdayDateRaw = moment.unix(this.selectedEmployeeItem.birthdayDate.seconds).format("YYYY-MM-DD")
      }
      this.selectedEmployeeItemOriginal = _.cloneDeep(this.selectedEmployeeItem)
      this.editEmployeeDialog = true
    },

    addResultArea(){
      this.newResultAreaDialog = true
    },

    editResultArea(item){
      this.selectedResultAreaItem = _.cloneDeep(item)
      this.selectedResultAreaItemOriginal = _.cloneDeep(item)
      this.editResultAreaDialog = true
    },

    addResultActivity(){
      this.newResultActivityDialog = true
    },

    editResultActivity(item){
      this.selectedResultActivityItem = _.cloneDeep(item)
      this.selectedResultActivityItemOriginal = _.cloneDeep(item)
      this.editResultActivityDialog = true
    },

    removeItemDialog(item, type){
      this.removeItemData.type = type
      this.removeItemData.data = item
      this.removeItemData.dialog = true
    },

    removeItem(){
      let collection = null

      if(this.removeItemData.type == 'medewerker'){
        collection = 'employees'
      }
      else if(this.removeItemData.type == 'functie'){
        collection = 'positions'
      }
      else if(this.removeItemData.type == 'kernactiviteit'){
        collection = 'resultActivities'
      }
      else if(this.removeItemData.type == 'resultaatgebied'){
        collection = 'resultAreas'
      }

      db.collection(collection)
        .doc(this.removeItemData.data.id)
        .set({
          deleted: {
            deleted: true,
            timestamp: new Date(),
            deletedBy: this.userFirstName + " " + this.userLastName
          }
        }, { merge: true })
        .then(() => {
          if(collection == 'employees'){
            this.loadEmployees();
          }
          else if(collection == 'positions'){
            this.loadPositions();
          }
          else if(collection == 'resultActivities'){
            this.loadPositions();
          }
          else if(collection = 'resultAreas'){
            this.loadResultAreas();
          }
        })
        .then(()=>{
          this.removeItemData.dialog = false
          this.removeItemData.type = null
          this.removeItemData.data = null
        })
        .catch(error => {
          this.removeItemData.dialog = false
          this.removeItemData.type = null
          this.removeItemData.data = null
          console.error("Error updating ", collection, ": ", error);
        });
    },


    loadUserComp() {
      this.loaded = false;
      let userCompanies = this.userCompanies;
      this.companies = [];
      let counter = 0

      new Promise((resolve, reject)=>{
        this.userCompanies.forEach(company=>{
          db.collection("companies").doc(company).get()
            .then(doc => {
              let company = {};
              company.name = doc.data().name;
              company.id = doc.id;
              this.companies.push(company);
              counter++
              if(counter == this.userCompanies.length){
                resolve()
              }
            })
        })
      })
      .then(()=>{
        // REMEMBER SELECTED COMPANY FROM LOCAL STORAGE
        if(this.userRole == 'superadmin'){
          // Super Admins have access to multiple companies 
          let selectedCompany = window.localStorage.getItem('selectedCompany')

          // Check if a selected company is set in the Local Storage
          if(selectedCompany){
            
            // Check if the selected company is an option
            let selectedCompanyIndex = _.findIndex(this.companies, { 'id': selectedCompany })

            // Selected company is an option, set activeComp
            if(selectedCompanyIndex >= 0){
              this.activeComp = this.companies[selectedCompanyIndex].id;
              this.loadActiveCompData();
            } 
            // Selected company is no option, set first company as activeComp 
            else{
              this.activeComp = this.companies[0].id;
              window.localStorage.setItem('selectedCompany', this.companies[0].id)
              this.loadActiveCompData();
            }
          }
          // No selected company is set 
          else {
            this.activeComp = this.companies[0].id;
            window.localStorage.setItem('selectedCompany', this.companies[0].id)
            this.loadActiveCompData();
          }
        }

        // Regular users have 1 company, just get the first
        else {
          this.activeComp = this.companies[0].id;
          this.loadActiveCompData();
          
        }
      })
    },

    loadActiveCompData() {
      this.loading = true;
      // Set Active Company as Selected Company in Local Storage
      window.localStorage.setItem('selectedCompany', this.activeComp)
      db.collection("companies")
        .doc(this.activeComp)
        .get()
        .then(doc => {
          if (doc.exists) {
            this.activeCompData = doc.data();
            this.activeCompData.id = doc.id;
          } else {
            console.log("No such document!");
          }
        })
        .then(() => {
          this.activeCompDataOriginal = _.cloneDeep(this.activeCompData);
           
          this.loadPositions();
          this.loadEmployees();
          this.loadResultAreas();
          this.loadBranches();
        })
        .then(() => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.error("Error getting document:", error);
        });
    },

      sortEmployees(a, b) {
        // Use toUpperCase() to ignore character casing
        const genreA = a.order;
        const genreB = b.order;

        let comparison = 0;
        if (genreA > genreB) {
          comparison = 1;
        } else if (genreA < genreB) {
          comparison = -1;
        }
        return comparison;
      },

      orderEmployees() {
        let element = document.querySelector(".table-employees tbody");
        const vm = this;
        Sortable.create(element, {
          handle: ".grapemp",
          onEnd({ newIndex, oldIndex }) {
            const rowSelected = vm.employees.splice(oldIndex, 1)[0]; // Get the selected row and remove it
            vm.employees.splice(newIndex, 0, rowSelected); // Move it to the new index
            vm.updateOrderEmployees();
          },
        });
      },

      updateOrderEmployees() {
        let counter = 0;
        this.watcher++ 
        new Promise((resolve)=>{
          let employees = _.cloneDeep(this.employees);
          employees.forEach((item) => {
            let index = employees.indexOf(item);
            this.employees[index].order = index;
            db.collection("employees").doc(item.id).set(
              {
                order: index,
              },
              { merge: true }
            )
            .then(()=>{
              counter++
              if(counter == employees.length){
                resolve();
              }
            })
          })
        })
        .then(()=>{
          this.watcher++ 
          setTimeout(()=> { 
            this.orderEmployees(); 
          }, 100);
        })
      

      },


  },

  computed: {

    resultActivitiesPosition(){
      return id => _.filter(this.resultActivities, ['position', id]);
    },

    scheduleStartDate(){
      let date = {
        readable: null,
        formatted: null,
        firebase: null,
        changed: false
      };
      if(this.scheduleStartDateRaw != null){
        date.readable = moment(this.scheduleStartDateRaw).format("D-M-YYYY");
        date.formatted = moment(this.scheduleStartDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(moment(this.scheduleStartDateRaw).format("YYYY/MM/DD"));
        date.changed = true;
        return date;
      }
      else if(this.employees[this.selectedEmployeeIndex].basicSchedule[this.employees[this.selectedEmployeeIndex].selectedBranch].startDate){
        date.readable = moment.unix(this.employees[this.selectedEmployeeIndex].basicSchedule[this.employees[this.selectedEmployeeIndex].selectedBranch].startDate.seconds).format("D-M-YYYY");
        date.formatted = moment.unix(this.employees[this.selectedEmployeeIndex].basicSchedule[this.employees[this.selectedEmployeeIndex].selectedBranch].startDate.seconds).format("YYYY/MM/DD");
        date.firebase = new Date(moment.unix(this.employees[this.selectedEmployeeIndex].basicSchedule[this.employees[this.selectedEmployeeIndex].selectedBranch].startDate.seconds).format("YYYY/MM/DD"));
        date.changed = false;
        return date
      }
      else {
        return date;
      }
    },

    scheduleEndDate(){
      let date = {
        readable: null,
        formatted: null,
        firebase: null,
        changed: false
      };
      if(this.scheduleEndDateRaw != null){
        date.readable = moment(this.scheduleEndDateRaw).format("D-M-YYYY");
        date.formatted = moment(this.scheduleEndDateRaw).format("YYYY/MM/DD");
        date.firebase = new Date(moment(this.scheduleEndDateRaw).format("YYYY/MM/DD"));
        date.changed = true;
        return date;
      }
      else if(this.employees[this.selectedEmployeeIndex].basicSchedule[this.employees[this.selectedEmployeeIndex].selectedBranch].endDate){
        date.readable = moment.unix(this.employees[this.selectedEmployeeIndex].basicSchedule[this.employees[this.selectedEmployeeIndex].selectedBranch].endDate.seconds).format("D-M-YYYY");
        date.formatted = moment.unix(this.employees[this.selectedEmployeeIndex].basicSchedule[this.employees[this.selectedEmployeeIndex].selectedBranch].endDate.seconds).format("YYYY/MM/DD");
        date.firebase = new Date(moment.unix(this.employees[this.selectedEmployeeIndex].basicSchedule[this.employees[this.selectedEmployeeIndex].selectedBranch].endDate.seconds).format("YYYY/MM/DD"));
        date.changed = false;
        return date
      }
      else {
        return date;
      }
    },

    basicScheduleChanged(){
      if (_.isEqual(this.employeeBranchScheduleEvents, this.employeeBranchScheduleEventsOriginal) &&  !this.scheduleStartDate.changed && !this.scheduleEndDate.changed) {
        return false;
      } 
      else {
        return true;
      }
    },

    employeeBranchBasicScheduleHours(){
      let hours = 0;
      if(this.employeeBranchScheduleEvents.length > 0){
        this.employeeBranchScheduleEvents.forEach(event=>{
          let start = moment(event.start.substr(event.start.length - 5),"HH:mm")
          let end = moment(event.end.substr(event.end.length - 5),"HH:mm")
          hours = hours + end.diff(start, 'hours', true); 
        })
        return hours;
      } else{
        return hours;
      } 
    },

   
    resultActivitiesFiltered(){
      return this.resultActivities.filter(resultActivity => {
        return (
          resultActivity.name.toLowerCase().indexOf(this.searchResultActivities.toLowerCase()) >= 0 
        );
      });
    },

    resultAreasFiltered(){
      return this.resultAreas.filter(resultArea => {
        return (
          resultArea.name.toLowerCase().indexOf(this.searchResultAreas.toLowerCase()) >= 0
        );
      });
    },

    randomHipster(){
      let randomNumber = Math.floor(Math.random() * 12) + 1;
      let hipsterClass = "hipster-" + randomNumber
      return hipsterClass    
    },

    userCompanies() {
      return this.$store.state.userCompanies;
    },
    userCompany() {
      return this.$store.state.userCompany;
    },
    userFirstName() {
      return this.$store.state.userFirstName;
    },
    userLastName() {
      return this.$store.state.userLastName;
    },
    userRole() {
      return this.$store.state.userRole;
    },
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },

    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },

    filteredCompanies(){
      if(this.searchCompanies && this.searchCompanies.length > 0){
        return this.companies.filter(company => {
          return company.name.toLowerCase().includes(this.searchCompanies.toLowerCase());
        });
      } else {
        return this.companies
      }
    },

    changed() {
      if(this.activeCompData.conversion.start && this.activeCompData.conversion.start.seconds){
        if (moment.unix(this.activeCompData.conversion.start.seconds).format("D MMMM YYYY") != this.conversionStartDate) {
          return true;
        } else {
          return false;
        }
      } else{
        if (this.conversionStartDate) {
          return true;
        } else {
          return false;
        }
      }
    }

  }
};
</script>


<style scoped>

.no-competention-data{
  width: 350px;
  margin: 0 auto;
  padding: 250px 0;
}

.conversion-source-tags{
  margin: 15px 0;
  padding: 10px 5px;
  background-color: #f9f9f9;
}
.conversion-source-tags:after{
  clear: both;
  display: block;
  content: "";
}

.tag-query{
  font-style: italic;
  font-size: 12px;
  margin: 0 0 0 5px;
}

.copy-tag-url{
  display: block;
  cursor: pointer!important;
  pointer-events: auto;
  text-align: center;
  color: #333;
  font-size: 12px;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently supported by Chrome, Opera and Firefox */
}

.copy-tag-url .v-icon{
  font-size: 12px!important;
}

.copy-tag-url.copied{
  font-style: italic;
   color: #000;
}

.copy-tag-url:hover{
  cursor: pointer!important;
  color: #000;
}

.not-found{
  width: 480px;
  margin: 0px auto;
  padding: 80px 0;
}
.not-found p{
  text-align: center;
}

.criterum-list-item{
  display: block;
}

.criterum-list-item:before {
  content: "•"; /* Insert content that looks like bullets */
  padding-right: 6px;
  color: #333; /* Or a color you prefer */
}

</style>
<style>
  .employee-calendar-wrapper .fc-axis.fc-widget-header,
  .employee-calendar-wrapper .fc-resource-cell{
    height: auto;
  }
  .employee-calendar-wrapper .fc-day-header.fc-widget-header{
    height: 25px;
    text-align: center;
    font-weight: bold;
  }
  tr.employee-expanded{
    background-color: var(--v-menuhover-base);
  }
  .employee-calendar-wrapper .fc-view-container{
    background-color: var(--v-menu-base);
  }

  .employee-calendar-wrapper .fc-resource-cell{
    text-align: center!important;
  }
  .employee-calendar-wrapper .fc-head:hover .fc-head-container.fc-widget-header,
  .employee-calendar-wrapper .fc-body:hover .fc-bg,
  .employee-calendar-wrapper table:hover,
  .employee-calendar-wrapper table tr:hover,
  .employee-calendar-wrapper .fc-body:hover td.fc-time{
    background: none!important;
  }

  .fc-unthemed td.fc-today{
    background: none;
  }

  .employee-calendar-wrapper .fc-toolbar.fc-header-toolbar{
    display: none;
  }

  .employee-calendar-wrapper td.fc-today,
  .employee-calendar-wrapperr .fc-unthemed td.fc-day.fc-widget-content,
  .employee-calendar-wrapper .fc-unthemed td.fc-today,
  .employee-calendar-wrapper .fc-day-today {
    background: var(--v-menu-base)!important;
  }

</style>